import React from 'react';
import './cardStats.css';

/**
 * Single metric tile — the primitive used across every stats surface
 * (CardsTab role tiles, CombosTab combo stats, ManabaseTab key metrics,
 * SynergyTab averages, and deck-pane summaries). Replaces the per-file
 * `KeyMetric` / `ComboStatTile` / `RoleTile` variants we had before.
 *
 * Props:
 * - `label`       — small monospace eyebrow above the value
 * - `value`       — the primary readout (number or ReactNode)
 * - `hint`        — optional italic detail below the value
 * - `accentColor` — override the left accent stripe (default seared red)
 * - `accentLabel` — when set, colors the label with the accent color too
 *                   (mirrors the old RoleTile treatment)
 * - `valueUnit`   — small uppercase unit label rendered next to value
 * - `footer`      — extra ReactNode footer (e.g. "avg score 561")
 * - `title`       — tooltip via `title` attribute
 */
export function StatMetricTile({
    label,
    value,
    hint,
    accentColor,
    accentLabel = false,
    valueColor,
    valueUnit,
    footer,
    title,
    className,
}) {
    const style = accentColor ? { borderLeftColor: accentColor } : undefined;
    const labelStyle = accentLabel && accentColor ? { color: accentColor } : undefined;
    const valueStyle = valueColor ? { color: valueColor } : undefined;
    return (
        <div
            className={`statsMetricTile ${className || ''}`.trim()}
            style={style}
            title={title}
        >
            {label && (
                <span className="statsMetricLabel" style={labelStyle}>
                    {label}
                </span>
            )}
            {valueUnit ? (
                <div className="statsMetricValueRow">
                    <span className="statsMetricValue" style={valueStyle}>
                        {value}
                    </span>
                    <span className="statsMetricValueUnit">{valueUnit}</span>
                </div>
            ) : (
                value != null && (
                    <span className="statsMetricValue" style={valueStyle}>
                        {value}
                    </span>
                )
            )}
            {hint && <span className="statsMetricHint">{hint}</span>}
            {footer && <span className="statsMetricFooter">{footer}</span>}
        </div>
    );
}
